import { Component, ViewChild, Renderer2, OnInit } from '@angular/core';
import { MapInfoWindow, GoogleMap } from '@angular/google-maps';
import { Store } from '@ngrx/store';
import { catchError, first, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { saveVehicles } from '@/core/reservation/store/vehicles.actions';
import { FindBranchesInternationalUseCase } from '@/core/domain/branches-international/usecases/findBranchesInternational.usecase';
import _ from 'lodash';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { UpdateReservationUseCase } from '@/core/domain/reservation/usecases/updateReservation.usecase';
import {
    BranchInt,
    BranchIntParams,
} from '@/core/domain/branches-international/models/branch-international.model';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';
import { selectLocationInt } from '@/core/international/store/international.selector';
import { SaveReservationUseCase } from '@/core/domain/reservation/usecases/saveReservation.usecase';
import { RestoreReservationUseCase } from '@/core/domain/reservation/usecases/restoreReservation.usecase';
import { saveLocations } from '@/core/reservation/store/locations.actions';
import { BreakpointService } from '@/common/services/breakpoint/breakpoint.service';
import { UrlService } from '@/common/services/url/url.service';
import { isValid } from '@/common/utils/validation/common.utils';
import { AlertService } from '@/common/services/alert/alert.service';

@Component({
    selector: 'fe-international',
    templateUrl: './international.component.html',
    styleUrls: ['./international.component.scss'],
})
export class InternationalComponent implements OnInit {
    @ViewChild(GoogleMap, { static: false }) map: GoogleMap | undefined;
    @ViewChild(MapInfoWindow, { static: false }) infoWindow:
        | MapInfoWindow
        | undefined;
    center: google.maps.LatLngLiteral = { lat: 23.634501, lng: -102.552784 };
    FindBranchesUseCase: any;
    zoom = 5;
    height = '100%';
    width = '100%';

    markers: any = [];

    public locations: BranchInt[] = [];
    public branchs$!: Observable<any>;
    public isMobile = false;
    public paramsServices: any;

    constructor(
        private store: Store,
        private readonly router: Router,
        private renderer: Renderer2,
        private updateReservation: UpdateReservationUseCase,
        private readonly findBranchesInternationalUseCase: FindBranchesInternationalUseCase,
        private readonly getAvailabilityInternational: GetAvailabilityInternationalUseCase,
        private readonly saveReservationUseCase: SaveReservationUseCase,
        private readonly restoreReservationUseCase: RestoreReservationUseCase,
        public reservation: CurrentReservationService,
        public breakpoint: BreakpointService,
        public url: UrlService,
        private alert: AlertService,
    ) {}

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 768;
        this.initReservation();
        this.fetchData();
    }

    private initReservation(): void {
        this.restoreReservationUseCase.execute().pipe(first()).subscribe();
    }

    private fetchData(): void {
        this.store
            .select(selectLocationInt)
            .pipe(first())
            .subscribe((response) => {
                if (response) {
                    this.paramsServices = response;
                    this.findBranchesInternationalUseCase
                        .execute(response)
                        .subscribe(
                            (locations) => {
                                this.locations = locations.data?.branches ?? [];
                                this.reservation.locations =
                                    locations.data?.branches ?? [];

                                const locationsStation: any[] = [];

                                _.forEach(
                                    this.reservation.locations,
                                    (item) => {
                                        locationsStation.push({
                                            id: item.stationId,
                                            stationId: item.stationId,
                                            locationType: item.locationType,
                                            name: item.name,
                                            address: item.address,
                                            gps: item.gps,
                                            location: 'INT',
                                            type: item.locationType.toLowerCase(),
                                        });
                                    },
                                );

                                this.store.dispatch(
                                    saveLocations({
                                        value: locationsStation,
                                    }),
                                );
                                this.createMarkersFromLocations(this.locations);
                            },
                            (error) => {
                                console.error('Error:', error);
                            },
                        );
                    this.center = { lat: response.lat, lng: response.lon };
                    this.zoom = 11;
                }
            });
    }

    private createMarkersFromLocations(locations: BranchInt[]): void {
        this.markers = locations.map((location, index) => ({
            id: location.stationId,
            position: {
                lat: location.gps.latitude,
                lng: location.gps.longitude,
            },
            label: {
                text: (index + 1).toString(),
                color: '#ffffff',
                fontSize: '22px',
                fontWeight: 'bold',
                className: 'custom-marker',
            },
            type: location.locationType,
            // title: location.name,
            location: location,
            options: {
                animation: google.maps.Animation.DROP,
                icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI1Ni4wMDMiIHZpZXdCb3g9IjkgMyA0NSA1Ni4wMDMiPjxwYXRoIGZpbGw9IiMwMDVEQUEiIHN0cm9rZT0iIzIxM0I3MyIgZD0iTTMxLjgyIDU4LjI2NWwxMC4zOTEtMTEuMjJINDlhNC41IDQuNSAwIDAgMCA0LjUtNC41VjhBNC41IDQuNSAwIDAgMCA0OSAzLjVIMTRBNC41IDQuNSAwIDAgMCA5LjUgOHYzNC41NDVhNC41IDQuNSAwIDAgMCA0LjUgNC41aDcuNDMzTDMxLjgyIDU4LjI2N3YtLjAwMnoiLz48L3N2Zz4=',
            },
        }));
    }

    selectMarckLocation(id: string, type: string, location: any) {
        this.store
            .select(selectLocationInt)
            .pipe(first())
            .subscribe((response) => {
                this.paramsServices = response;

                const locationInt: BranchIntParams = {
                    id: location.stationId,
                    location: response.location,
                    fRenta: response.fRenta,
                    hRenta: response.hRenta,
                    fDevolucion: response.fDevolucion,
                    hDevolucion: response.hDevolucion,
                    type: location.locationType.toLowerCase(),
                };

                if (isValid(this.reservation.current.age)) {
                    locationInt.age = this.reservation.current
                        .age as unknown as string;
                }

                this.getAvailabilityInternational
                    .execute(locationInt)
                    .pipe(
                        catchError((error) => {
                            this.alert.openDefault(error);
                            return throwError(() => error);
                        }),
                    )
                    .subscribe((locations) => {
                        this.updateReservation
                            .execute({
                                locationSelected: location.stationId,
                                location: {
                                    id: location.stationId,
                                    name: location.name,
                                },
                                locationName: location.name,
                            })
                            .subscribe();

                        this.reservation.current.location = [id];
                        this.store.dispatch(
                            saveVehicles({ value: locations.data }),
                        );
                        this.router.navigate(
                            [
                                this.url.format(
                                    'reservations/cars-and-categories',
                                ),
                            ],
                            {
                                state: {
                                    international: true,
                                },
                            },
                        );
                    });
            });
    }

    onMouseOver(id: any) {
        const element = document.getElementById('card_location_int-' + id);
        if (element) {
            this.renderer.addClass(element, 'focus');
        }
    }

    onMouseOut(id: any) {
        const element = document.getElementById('card_location_int-' + id);
        if (element) {
            this.renderer.removeClass(element, 'focus');
        }
    }
}
